<app-capture-history-item-title>
  Capture Details Updated
</app-capture-history-item-title>

<app-capture-history-item-body>
  @if (statusReasons) {
    <p>
      {{ displayStatus }}: {{ statusReasons }}
    </p>
  }

  @if (additionalDetails !== undefined) {
    <p>
      Additional Details: {{ additionalDetails | blankValueDash }}
    </p>
  }

  @if (verifiedAtChanges) {
    <p>
      Verified At Changed From "{{ verifiedAtChanges[0] | date: 'MM/dd/yyyy' }}" To "{{ verifiedAtChanges[1] | date: 'MM/dd/yyyy' }}"
    </p>
  }

  @if (verifiedInvalidReviewedChanges && verifiedInvalidReviewedEnabled) {
    <p>
      Verified Invalid Review
    </p>
  }
  @if (verifiedInvalidReviewedChanges && !verifiedInvalidReviewedEnabled) {
    <p>
      Verified Invalid Review Removed
    </p>
  }
</app-capture-history-item-body>
